<mat-card>
  <img src="assets/img/logo_alcmeon_horizontal.png" />
  <form [formGroup]="form" (ngSubmit)="submit()">
    <mat-card-content>
      <p translate="password-request/description"></p>
      <mat-form-field appearance="outline">
        <mat-label translate="password-request/email"></mat-label>
        <input type="email" matInput formControlName="email" [placeholder]="'password-request/email' | translate" />
      </mat-form-field>
    </mat-card-content>
    <button
      mat-raised-button
      color="primary"
      translate="password-request/submit"
      type="submit"
      [disabled]="form.invalid"></button>
  </form>
</mat-card>
